import { render, staticRenderFns } from "./AllCountryCardDeck.vue?vue&type=template&id=835a20b6&scoped=true&"
import script from "./AllCountryCardDeck.vue?vue&type=script&lang=js&"
export * from "./AllCountryCardDeck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835a20b6",
  null
  
)

export default component.exports